import produce from 'immer';
import {
  GET_CUSTOMER_SUBSCRIPTIONS_LIST_START,
  GET_CUSTOMER_SUBSCRIPTIONS_LIST_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTIONS_LIST_FAILED,
  GET_CUSTOMER_SUBSCRIPTION_START,
  GET_CUSTOMER_SUBSCRIPTION_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTION_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_START,
  EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED,
  GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START,
  GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS,
  EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START,
  EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTION_SHIPPING_START,
  GET_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_START,
  EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTION_HISTORY_FAILED,
  GET_CUSTOMER_SUBSCRIPTION_HISTORY_START,
  GET_CUSTOMER_SUBSCRIPTION_HISTORY_SUCCESS,
  GET_SUBSCRIPTION_SOTRE_PICKUP_ADDRESS_SUCCESS,
  GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_FAILED,
  GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_START,
  BILL_CUSTOMER_SUBSCRIPTION_START,
  BILL_CUSTOMER_SUBSCRIPTION_SUCCESS,
  BILL_CUSTOMER_SUBSCRIPTION_FAILED,
  DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_START,
  DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_SUCCESS,
  DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_FAILED,
  EDIT_CUSTOMER_SUBSCRIPTION_PRICE_START,
  EDIT_CUSTOMER_SUBSCRIPTION_PRICE_SUCCESS,
  EDIT_CUSTOMER_SUBSCRIPTION_PRICE_FAILED
} from 'redux/actions/customer_subscriptions';
import { CHANGE_ACTIVE_STORE_SUCCESS } from 'redux/actions/user';


const initialState = {
  customerSubscriptionsList: [],
  isCustomerSubscriptionsLoading: false,
  isCustomerSubscriptionPriceLoading: false,
  isSubscriptionBillingInfoLoading: false,
  isCustomerSubscriptionShippingLoading: false,
  isSubscriptionBilling: false,
  customerSubscriptionsTotalCount: 0,
  editableCustomerSubscription: {} as ICustomerSubscription,
  customerSubscriptionBillingInfo: {},
  customerSubscriptionShipping: {},
  customerSubscriptionHistory: [],
  subscriptionStorePickupAddresses: [],
  customerSubscriptionHistoryTotalCount: 0,
  isCustomerSubscriptionHistoryLoading: false,
  isLoadingSubscriptionStorePickup: false,
  downloadingSubscriptionReport: false
};

const formReducer = produce((state: ICustomerSubscriptionsState = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_SUBSCRIPTIONS_LIST_START: {
      state.isCustomerSubscriptionsLoading = true;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTIONS_LIST_SUCCESS: {
      const {data} = action;

      state.customerSubscriptionsList = data.subscriptions.items;
      state.customerSubscriptionsTotalCount = data.subscriptions.total_count;
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTIONS_LIST_FAILED: {
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_START: {
      state.isCustomerSubscriptionsLoading = true;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_SUCCESS: {
      const {data} = action;

      state.editableCustomerSubscription = data.subscription;
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_FAILED: {
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_START: {
      state.isCustomerSubscriptionsLoading = true;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS: {
      const { data } = action;

      state.editableCustomerSubscription = data.subscription;
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_FAILED: {
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_PRICE_START: {
      state.isCustomerSubscriptionsLoading = true;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_PRICE_SUCCESS: {
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_PRICE_FAILED: {
      state.isCustomerSubscriptionsLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START: {
      state.isSubscriptionBillingInfoLoading = true;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS: {
      const { data } = action;

      state.customerSubscriptionBillingInfo = data.payment;
      state.isSubscriptionBillingInfoLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED: {
      state.isSubscriptionBillingInfoLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START: {
      state.isSubscriptionBillingInfoLoading = true;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS: {
      const { data } = action;

      state.customerSubscriptionBillingInfo = data.payment;
      state.isSubscriptionBillingInfoLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED: {
      state.isSubscriptionBillingInfoLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_SHIPPING_START: {
      state.isCustomerSubscriptionShippingLoading = true;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS: {
      const { data } = action;

      state.customerSubscriptionShipping = data.shipping;
      state.isCustomerSubscriptionShippingLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED: {
      state.isCustomerSubscriptionShippingLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_START: {
      state.isCustomerSubscriptionShippingLoading = true;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS: {
      const { data } = action;

      state.customerSubscriptionShipping = data.shipping;
      state.isCustomerSubscriptionShippingLoading = false;
      break;
    }
    case EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED: {
      state.isCustomerSubscriptionShippingLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_HISTORY_START: {
      state.isCustomerSubscriptionHistoryLoading = true;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_HISTORY_SUCCESS: {
      const { data } = action;

      state.customerSubscriptionHistory = data.history.items;
      state.customerSubscriptionHistoryTotalCount = data.history.total_count;
      state.isCustomerSubscriptionHistoryLoading = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTION_HISTORY_FAILED: {
      state.isCustomerSubscriptionHistoryLoading = false;
      break;
    }
    case GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_START: {
      state.isLoadingSubscriptionStorePickup = true;
      break;
    }
    case GET_SUBSCRIPTION_SOTRE_PICKUP_ADDRESS_SUCCESS: {
      const { data } = action;

      state.subscriptionStorePickupAddresses = data.data;
      state.isLoadingSubscriptionStorePickup = false;
      break;
    }
    case GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_FAILED: {
      state.isLoadingSubscriptionStorePickup = false;
      break;
    }
    case BILL_CUSTOMER_SUBSCRIPTION_START: {
      state.isSubscriptionBilling = true;
      break;
    }
    case BILL_CUSTOMER_SUBSCRIPTION_SUCCESS: {
      state.isSubscriptionBilling = false;
      break;
    }
    case BILL_CUSTOMER_SUBSCRIPTION_FAILED: {
      state.isSubscriptionBilling = false;
      break;
    }

    case DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_START: {
      state.downloadingSubscriptionReport = true;
      break;
    }

    case DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_SUCCESS: {
      state.downloadingSubscriptionReport = false;
      break;
    }

    case DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_FAILED: {
      state.downloadingSubscriptionReport = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.customerSubscriptionsList = initialState.customerSubscriptionsList;
      state.customerSubscriptionsTotalCount = initialState.customerSubscriptionsTotalCount;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
